import { useState, useEffect } from 'react';

import { normalizeString } from '../../../helpers/admin/productHelper';
import { formatProductReviews, mainVariantOnly } from '../../../helpers/shop/shopHelper';

import shape from '../../../assets/resources/shape.png';

//MUI
import {
    Alert, Box, Container, Grid, Typography, useMediaQuery,
    Stack, FormControl, InputLabel, Select, MenuItem, IconButton
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

//Router dom
import { Link, useParams } from 'react-router-dom';

//Redux
import { useSelector } from 'react-redux';

const SearchComponent = () => {
    const matches = useMediaQuery('(max-width: 950px)');
    const { product_field } = useParams();

    const { products } = useSelector(state => state.shop);

    // productos de tienda
    const [filteredProducts, setFilteredProducts] = useState([]);

    const [filter, setFilter] = useState('');
    const [searchParameter, setSearchParameter] = useState('');

    useEffect(() => {
        setSearchParameter(product_field.toLowerCase());
    }, [product_field]);

    useEffect(() => {
        if (searchParameter)
            setProducts();
    }, [products, searchParameter]);

    const setProducts = () => {
        setFilteredProducts(
            products.filter(
                ({ title, prod_variants, keywords }) => {
                    const full_title = normalizeString(title);
                    const variants_title = prod_variants.map(({ variant_title }) => variant_title.toLowerCase()).join(" ");
                    return (
                        full_title.includes(searchParameter)
                        || keywords.includes(searchParameter)
                        || keywords.filter(e => e.indexOf(searchParameter) >= 0).length > 0
                        || (variants_title && variants_title.includes(searchParameter))
                    ) ? true : false;
                }
            )
        );
    };

    // obtener precio menor de variantes para filtro
    const getMinPrice = (p) => {
        const prices = p.prod_variants.map(e => e.price);
        const min = Math.min(...prices);
        return min;
    };

    // obtener promedio de reseñas para filtro
    const getAverageReview = (p) => {
        return Number(p.review_summary?.average || 0);
    };

    // filtrar productos
    const onChangeFilter = ({ target }) => {
        setFilter(target.value);
        const arr = [...filteredProducts];
        switch (target.value) {
            case '10': // menor precio
                setFilteredProducts(arr.sort(function (a, b) {
                    const a_min = getMinPrice(a);
                    const b_min = getMinPrice(b);
                    return (a_min > b_min) ? 1 : ((b_min > a_min) ? -1 : 0);
                }));
                break;
            case '20': // mayor precio
                setFilteredProducts(arr.sort(function (a, b) {
                    const a_min = getMinPrice(a);
                    const b_min = getMinPrice(b);
                    return (a_min < b_min) ? 1 : ((b_min < a_min) ? -1 : 0);
                }));
                break;
            case '30': // nombre ascendente
                setFilteredProducts(arr.sort(function (a, b) {
                    return (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0);
                }));
                break;
            case '40': // nombre descendente
                setFilteredProducts(arr.sort(function (a, b) {
                    return (a.title < b.title) ? 1 : ((b.title < a.title) ? -1 : 0);
                }));
                break;
            case '50':
                setFilteredProducts(arr.sort(function (a, b) {
                    const a_prom = getAverageReview(a);
                    const b_prom = getAverageReview(b);
                    return (a_prom < b_prom) ? 1 : ((b_prom < a_prom) ? -1 : 0);
                }));
                break;
            default:
                break;
        }
    };

    const handleClear = () => {
        setProducts();
        setFilter('');
    };

    return (
        <Container maxWidth='xl' sx={{ mt: matches ? 5 : 18 }} className="last-view">
            <Typography variant='body1' sx={{ fontSize: '26px', mb: 5 }}>
                {
                    `${filteredProducts.length} ${
                        filteredProducts.length > 1 || filteredProducts.length < 1
                        ? 'resultados' : 'resultado'
                    } para `
                } <span style={{ fontWeight: 'bold' }}>"{
                    searchParameter
                }"</span>
            </Typography>

            {/* Filtros */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '15px', mb: 3 }}>
                <FormControl className="order-by-shop" size="small">
                    <InputLabel>Ordenar por:</InputLabel>
                    <Select
                        name={filter}
                        label="Ordenar por:"
                        defaultValue={filter}
                        value={filter}
                        onChange={onChangeFilter}
                    >
                        <MenuItem value={'10'}><i className="fa-solid fa-down-long" style={{ marginRight: '10px' }}></i>Menor precio</MenuItem>
                        <MenuItem value={'20'}><i className="fa-solid fa-up-long" style={{ marginRight: '10px' }}></i>Mayor precio</MenuItem>
                        <MenuItem value={'30'}><i className="fa-solid fa-up-long" style={{ marginRight: '10px' }}></i>Nombre A - Z</MenuItem>
                        <MenuItem value={'40'}><i className="fa-solid fa-down-long" style={{ marginRight: '10px' }}></i>Nombre Z - A</MenuItem>
                        <MenuItem value={'50'}>Rating</MenuItem>
                    </Select>
                </FormControl>
                {
                    filter &&
                        <IconButton onClick={handleClear} size='small'>
                            <ClearIcon fontSize='small' />
                        </IconButton>
                }
            </Box>

            <Grid container spacing={3}>
                {
                    filteredProducts.length >= 1 ?
                        filteredProducts.map(({
                            _id, title, url, prod_variants, review_summary
                        }) => {
                            const { // datos de variante a mostrar
                                full_title, price, barcode, item_promotion, img
                            } = mainVariantOnly(title, prod_variants);
                            
                            // reseñas de producto
                            const { review_prom, review_count } = formatProductReviews(review_summary);
                            const { promo, price: promo_price, text, fontSize, description: promotionDescription } = item_promotion;
                            
                            return (
                                <Grid item xl={3} lg={4} md={6} sm={6} xs={12} key={_id}>
                                    <Grid container rowSpacing={1} columnSpacing={3} className="product-shop">
                                        <Grid item xl={12} lg={12} md={12} sm={12} xs={5}
                                            sx={{ my: 'auto', textAlign: 'center' }}>
                                            <Link to={`/tienda/producto/${url}/${barcode}`}>
                                                <div className="product-in-promotion">
                                                    <img src={ img.id }
                                                        width='100%' style={{ objectFit: 'contain' }}
                                                        className="shop-product" alt={ img.alt }
                                                    />
                                                    {
                                                        promo !== '' &&
                                                        <div className="shop_top-image" title={promotionDescription}>
                                                            <img src={shape} alt={shape} width='75'
                                                                style={{ pointerEvents: 'none' }}
                                                            />
                                                            <div className="shop_centered_image">
                                                                <Typography sx={{ color: '#fff', fontSize, fontWeight: 'bold' }}>
                                                                    { text }
                                                                </Typography>
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </Link>
                                        </Grid>

                                        <Grid item xl={12} lg={12} md={12} sm={12} xs={7} sx={{ my: 'auto' }}>
                                            <Box sx={{ textAlign: { xs: 'flex-start', sm: 'center', md: 'center' } }}>
                                                <Link to={`/tienda/producto/${url}/${barcode}`} style={{ textDecoration: 'none', color: '#000' }}
                                                    className='product_name'>
                                                    <Typography
                                                        variant="body1"
                                                        component="div"
                                                        sx={{ fontWeight: '600' }}
                                                    >
                                                        { full_title }
                                                    </Typography>
                                                </Link>
                                            </Box>

                                            <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', sm: 'center', md: 'center' }, mt: 1 }}>
                                                <div className="ratings-shop">
                                                    {
                                                        review_count > 0 ?
                                                            Array.from(Array(review_prom), (e, j) => {
                                                                return <i className="fas fa-star"
                                                                    style={{
                                                                        color: '#FFA41C',
                                                                        stroke: "#FFA41C",
                                                                        strokeWidth: 0.2
                                                                    }}
                                                                    key={j}></i>
                                                            })
                                                            :
                                                            <>
                                                                <i className="far fa-star"></i>
                                                                <i className="far fa-star"></i>
                                                                <i className="far fa-star"></i>
                                                                <i className="far fa-star"></i>
                                                                <i className="far fa-star"></i>
                                                            </>
                                                    }
                                                </div>
                                            </Box>

                                            <Box sx={{
                                                display: 'flex', mt: 1,
                                                justifyContent: { xs: 'flex-start', sm: 'center', md: 'center' }
                                            }}>
                                                {
                                                    ['DescuentoProducto', 'DescuentoMarca'].includes(promo) ?
                                                        <Stack
                                                            direction="row"
                                                            justifyContent="flex-start"
                                                            alignItems="baseline"
                                                            spacing={1}>
                                                            <Typography variant="h6"
                                                                sx={{ fontWeight: '600', color: '#000', textDecoration: 'line-through' }}>
                                                                ${price}
                                                            </Typography>
                                                            <Typography variant="h6"
                                                                sx={{ fontWeight: '600', color: '#F90606' }}>
                                                                ${promo_price}
                                                            </Typography>
                                                        </Stack>
                                                    :
                                                        <Typography variant="h6"
                                                            sx={{ fontWeight: '600', color: '#F90606' }}>
                                                            ${price}
                                                        </Typography>
                                                }
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )
                        })
                    :
                        <Grid item xs={12}>
                            <Alert severity="info" sx={{ mt: 3 }}>
                                No hay ninguna coincidencia
                            </Alert>
                        </Grid>
                }
            </Grid>
        </Container>
    );
};

export default SearchComponent;
